import { render } from "./PortfolioBox.vue?vue&type=template&id=e5ad00dc"
import script from "./PortfolioBox.vue?vue&type=script&lang=js"
export * from "./PortfolioBox.vue?vue&type=script&lang=js"

import exportComponent from "H:\\Projects\\Jesta\\Front\\Jesta-Group\\Dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__